import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

export const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'company',
});

export function getProfileByJobId(id) {
    return backendEndpoint.get('profile-by-job-id', { params: { jobId: id } });
}
